import { useCallback } from 'react';
import { useStore } from '@/utils/store';
import { formatCurrency } from '@/utils/format';

export function useCurrency() {
  const currency = useStore((s) => s.user.currency || 'CLP');
  const setCurrency = useStore((s) => s.updateUser);

  const format = useCallback(
    (amount) => formatCurrency(amount, currency),
    [currency]
  );

  return { currency, setCurrency: (c) => setCurrency({ currency: c }), format };
}
